/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { NavCardsSimpleEditor } from "cms/components/components/nav-cards-simple/edit";
import { NavCardsSimpleDisplay } from "cms/components/components/nav-cards-simple/display";
import { getComponentZoneLayout } from "cms/components/components/component";

const NavCardsSimple = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <NavCardsSimpleDisplay />,
        editComponent: <NavCardsSimpleEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

NavCardsSimple.displayName = "NavCardsSimple";
export { NavCardsSimple };
